export const THEME_KEY = "@vistra-theme";

export const CHOOSE_THEME = "@vistra-choose-theme";
